import { ViewModel, type ContactSubmit } from "@lumora/core";
import { SampleRequest } from "../models/SampleRequest.js";

export interface SampleState {
  name: string;
  email: string;
  productUrl: string;
  category: string;
  photoUrl1: string;
  photoUrl2: string;
  errors: string[];
  submitting: boolean;
  submitted: boolean;
}

/** Binds the free-sample form View to a SampleRequest and the shared contact submit path. */
export class SampleViewModel extends ViewModel<SampleState> {
  constructor(private readonly onSubmit: ContactSubmit) {
    super({
      name: "", email: "", productUrl: "", category: "", photoUrl1: "", photoUrl2: "",
      errors: [], submitting: false, submitted: false,
    });
  }

  setField<K extends "name" | "email" | "productUrl" | "category" | "photoUrl1" | "photoUrl2">(key: K, value: string): void {
    this.setState({ [key]: value } as Pick<SampleState, K>);
  }

  private request(): SampleRequest {
    const { name, email, productUrl, category, photoUrl1, photoUrl2 } = this.state;
    return new SampleRequest({ name, email, productUrl, category, photoUrl1, photoUrl2 });
  }

  async submit(): Promise<boolean> {
    const req = this.request();
    const errors = req.validate();
    if (errors.length > 0) {
      this.setState({ errors });
      return false;
    }
    const ok = await this.run(
      async () => {
        await this.onSubmit(req.toContactMessage());
        this.setState({ submitted: true });
        return true;
      },
      "Could not send your request. Please try again.",
      { flag: "submitting", listErrors: true },
    );
    return ok === true;
  }
}
